// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14de7105","667":"34be2a20"}[chunkId] + ".chunk.js";
};